import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Directive, Input } from '@angular/core';

import { Store } from '@ngxs/store';

import { AdGroup } from '@app/core/models/ad-group.models';
import { Account, Campaign, Criteria } from '@app/core/models/common.models';
import { UserState } from '@app/core/store/states/user/user.state';
import { AdGroupCampaignTypeSettings, UserSetting } from '@app/core/models/user.models';

@Directive()
export abstract class ItemLabelComponent<
  T extends
    | Pick<Account, 'accountName' | 'accountId'>
    | Pick<Campaign, 'performanceGroupName' | 'performanceGroupOptimizationType'>
    | Pick<Campaign, 'campaignName' | 'campaignType'>
    | Pick<AdGroup, 'adgroupName'>
    | Pick<Criteria, 'criterionName'>,
> {
  abstract labelProperty: keyof T;

  abstract get type(): string;

  get label(): string {
    return this.item?.[this.labelProperty] as string;
  }

  disableTypeTranslate = false;

  readonly adGroupCampaignTypeSetting$: Observable<AdGroupCampaignTypeSettings> = this.store.select(
    UserState.setting(UserSetting.AdGroupCampaignType, { visible: true }),
  );

  readonly showType$: Observable<boolean> = this.adGroupCampaignTypeSetting$.pipe(map((setting) => setting.visible));

  @Input()
  item?: T;

  @Input()
  labelClass?: string;

  @Input()
  typeClass: string = 'label-2';

  @Input()
  truncate?: number;

  constructor(private store: Store) {}
}
